<template>
  <section class="Introduction__benefits">
    <div class="inner">
      <h2 class="Head__frame Head__frame_blue">
        <span class="Head__frame_blue_inner">特典内容</span>
      </h2>
      <div class="Introduction__bottom_area Introduction__benefits_area">
        <div class="Introduction__bottom_inner Introduction__benefits_line">
          <h3 class="Introduction__head_chara Introduction__head_chara--row Introduction__head_chara--pink">
            紹介された人
          </h3>
          <div class="Introduction__bottom_tx_area">
            <p class="Introduction__bottom_tx">
              紹介URLからのご登録で<br class="Introduction__bottom_tx_br">MELONの利用料が<span class="Introduction__bottom_tx_blue">1ヶ月無料</span>
            </p>
          </div>
          <p class="Introduction__bottom_notes _dsp-none--pc">
            ※2ヶ月目の利用料が無料となります
          </p>
        </div>
      </div>
      <p class="Introduction__bottom_notes _dsp-none--sp">
        ※2ヶ月目の利用料が無料となります
      </p>
      <div class="Introduction__top_area Introduction__benefits_line">
        <h3 class="Introduction__head_chara Introduction__head_chara--row Introduction__head_chara--green">
          紹介した人
        </h3>
        <div class="Introduction__top_main">
          <div class="Introduction__top_main_top">
            <div class="Introduction__top_main_top_r Introduction__arrow_frame Introduction__arrow_frame--md">
              1名様<br class="_dsp-none--pc">ご紹介<span class="_dsp-none--sp">で</span>
            </div>
            <div class="Introduction__top_main_top_l Introduction__top_main_top_l_tx">
              <span class="Introduction__top_main_top_l_tx--md">利用料</span><span class="Introduction__top_main_top_l_tx--sm">が<br class="_dsp-none--pc"></span><span class="_font-lg">1ヶ月無料</span>
            </div>
          </div>
          <div class="Introduction__top_main_bottom_head">
            2名様以上ご紹介で
          </div>
          <div class="Introduction__top_main_bottom">
            <div class="Introduction__top_main_bottom_r">
              <div class="Introduction__top_main_bottom_r_box">
                <div class="Introduction__top_main_bottom_r_box_top">
                  2名様
                </div>
                <div class="Introduction__top_main_bottom_r_box_bottom">
                  2ヶ月無料
                </div>
              </div>
              <div class="Introduction__top_main_bottom_r_box">
                <div class="Introduction__top_main_bottom_r_box_top">
                  3名様
                </div>
                <div class="Introduction__top_main_bottom_r_box_bottom">
                  3ヶ月無料
                </div>
              </div>
            </div>
            <div class="Introduction__top_main_bottom_l">
              <div class="Introduction__top_main_bottom_l_img_box">
                <div class="Introduction__top_main_bottom_l_img_box_tx Introduction__top_main_bottom_l_img">
                  <div>
                    <span class="_mg-r05em">\</span>何人でもご紹介いただけます<span class="_mg-l05em">/</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'IntroductionBenefit'
}
</script>
